// extracted by mini-css-extract-plugin
module.exports = {"options":"panelTrigger_options__3aO8S","optionOne":"panelTrigger_optionOne__37Au0","optionTwo":"panelTrigger_optionTwo__3QkxN"};